import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import { AppContext } from "../../../contexts/AppContext";
import RouteNames from "../../../contexts/RouteNames";
import { getFromStorage } from "../../../services/LocalStorage";
import { fetchLocationConfigurations } from "../../../services/OrderService";
import { Header } from "../Header";
import { SettingsTabView } from "./SettingsTabView";

const Wrapper = styled.div`
    background-color: #ffffff;
    padding-top: 20px;
    height: 100%;
    overflow: auto;
    width: 100%;
`;
const Container = styled.nav`
    margin: auto;
    height: 100%;
    width: 100%;
    display: flex;
    height: calc(100% - 60px);
`;

export function Settings() {
    const history = useHistory();
    const { authData, kitchen, setDefaultDeliveryMode, setAvailableDeliveryModes, setCurrentRouteName } = useContext(AppContext);
    
    useEffect(() => {
        setCurrentRouteName(RouteNames.DISPATCHER_SETTINGS);
    }, [])

    useEffect(() => {
    
        if (!authData) {
            history.replace('/login')
            return
        }
    
        let loadedKitchen = kitchen;
        if (!loadedKitchen.id) {
            loadedKitchen = getFromStorage('kitchen');
        }
    
        fetchLocationConfigurations(authData.signInUserSession.idToken.payload.partner_id, loadedKitchen.id).then((response) => {
            setDefaultDeliveryMode(response.defaultDeliveryMode);
            setAvailableDeliveryModes(response.availableDeliveryModes);
        }).catch((e) => {
            console.log(e);
        });
    
    }, []);

    return (
        <Wrapper>
            <Header mode={"settings"} />
            <div style={{ borderTop: "1px solid #EDEDED" }}></div>
            <Container>
                <SettingsTabView />
            </Container>
        </Wrapper>
    );
}
